import React, { useEffect } from 'react'
import { useHistory } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { Form, Formik } from 'formik'
import Swal from 'sweetalert2'
import { Alert } from '@wellbeingxltd/fe-lib/components'
import { GET_STORE } from '@wellbeingxltd/fe-lib/constants'
import SupplierActions from 'store/models/supplier'
import { Button } from 'components'
import { TextFlow } from './TextFlow'
import styles from '../Shopify.module.scss'

export const Instructions = ({ completedStep, setCompletedStep }) => {
    const { supplierId } = JSON.parse(localStorage.getItem('supplier'))

    const dispatch = useDispatch()
    const history = useHistory()
    const { shopifyDetails = {}, loadingRemoveShopifyDetails, loadingUpdateShopifyDetails } = useSelector(GET_STORE.SUPPLIER)

    const { shopifyApiKey, shopifyAccessToken, shopifyStoreDomain } = shopifyDetails

    useEffect(() => {
        dispatch(SupplierActions.getShopifyDetails(supplierId))
    }, [])

    const integrationComplete = shopifyApiKey && shopifyAccessToken && shopifyStoreDomain

    /*  fulfillmentsCreateWebhook, updateFulfillmentsWebhook & orderCancellationWebhook = false 
    if shopifyApiKey, shopifyAccessToken & shopifyStoreDomain already existed */
    const initialValues = {
        supplierId,
        shopifyApiKey: shopifyApiKey || '',
        shopifyAccessToken: shopifyAccessToken || '',
        shopifyStoreDomain: shopifyStoreDomain || '',
        fulfillmentsCreateWebhook: shopifyApiKey && shopifyAccessToken && shopifyStoreDomain ? false : true,
        updateFulfillmentsWebhook: shopifyApiKey && shopifyAccessToken && shopifyStoreDomain ? false : true,
        orderCancellationWebhook: shopifyApiKey && shopifyAccessToken && shopifyStoreDomain ? false : true,
        orderRefundWebhook: shopifyApiKey && shopifyAccessToken && shopifyStoreDomain ? false : true,
    }

    const onChange = (event, step) => {
        if (event.target.checked) {
            setCompletedStep(step)
            localStorage.setItem('completedStep', step)
        } else {
            setCompletedStep(step - 1)
            localStorage.setItem('completedStep', step - 1)
        }
    }

    const onSubmit = values =>
        dispatch(
            SupplierActions.updateShopifyDetails(values, (message, type) => {
                Alert(message, type)
                if (type === 'success') history.push('/directory')
            })
        )

    const removeShopifyHandler = event => {
        event.preventDefault()

        Swal.fire({
            title: 'Are you sure?',
            html: `<p>
                    This will remove your Shopify API key from your Betterspace Supplier account and unlink all products.
                    <br />
                    You will have to fulfil orders manually from the Transactions page.
                    <br />
                    If you change your mind, you can always integrate your Shopify store and link your products again.
                </p>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, remove it!',
            cancelButtonText: 'No, cancel!',
        }).then(result => {
            if (result.isConfirmed) {
                dispatch(SupplierActions.removeShopifyDetails(supplierId, (msg, type) => Alert(msg, type)))
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Alert('Cancelled', 'error')
            }
        })
    }

    return (
        <div className={`module ${styles.Instructions}`}>
            <Formik enableReinitialize={true} initialValues={initialValues} onSubmit={onSubmit}>
                {({ touched }) => (
                    <Form autoComplete="off">
                        <TextFlow {...{ initialValues, completedStep, onChange, integrationComplete }} />
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Button
                                className={styles.button}
                                type="submit"
                                loading={loadingUpdateShopifyDetails}
                                disabled={!Object.keys(touched).length}
                            >
                                Save and continue
                            </Button>
                            {Object.keys(shopifyDetails).length ? (
                                <Button
                                    className={styles.removeButton}
                                    variant="stress"
                                    size="middle"
                                    onClick={removeShopifyHandler}
                                    loading={loadingRemoveShopifyDetails}
                                >
                                    Remove Shopify integration
                                </Button>
                            ) : null}
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    )
}
